export default __webpack_public_path__ + "static/media/shop-icon.048628c9.svg";